/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect, useMemo } from 'react';
// material
import Space from 'material/space/space';
// styles
import injectSheet from 'react-jss'
import styles from './devices_styles'
import SectionGroupV2 from 'material/expandablesection/v2/sectiongroupv2/sectiongroupv2';
import { Control } from '@insticator/insticator-ui/dist/material';

/* ========== ~~~~~~~~~~ PRODUCT MANAGER: SITE SETUP : FEATURES ~~~~~~~~~~ ========== */
const Devices = injectSheet(styles)((props) => {

  const { deviceType, onChange } = props

  const isDesktop = deviceType === 'ALL' || deviceType === 'DESKTOP'
  const isMobile = deviceType === 'ALL' || deviceType === 'MOBILE'

  const handleDesktopSelect = () => {
    if(deviceType === 'ALL')
      onChange('deviceType', 'MOBILE')
    if(deviceType === 'DESKTOP') 
      onChange('deviceType', null)
    if(deviceType === null)
      onChange('deviceType', 'DESKTOP')
    if(deviceType === 'MOBILE')
      onChange('deviceType', 'ALL')
  }

  const handleMobileSelect = () => {
    if(deviceType === 'ALL')
      onChange('deviceType', 'DESKTOP')
    if(deviceType === 'MOBILE') 
      onChange('deviceType', null)
    if(deviceType === null)
      onChange('deviceType', 'MOBILE')
    if(deviceType === 'DESKTOP')
      onChange('deviceType', 'ALL')
  }

  const noDeviceSelected = !isDesktop && !isMobile

  return (
    <SectionGroupV2 
      klass={`devices ${props.classes.devices}`} 
      title={'Devices'} 
      description={'Select which device(s) this group will display for on your site.'}
    >
     <Space direction={'column'}>
      <Space>
          <Control 
              text={'Desktop'} 
              value={'DESKTOP'} 
              handleSelect={() => handleDesktopSelect()} 
              variant={'system'} 
              addCheckWhenSelected={true}
              selected={isDesktop}  
          />
          <Control 
              text={'Mobile'} 
              value={'MOBILE'}
              handleSelect={() => handleMobileSelect()} 
              variant={'system'} 
              addCheckWhenSelected={true}
              selected={isMobile}  
          />
        </Space>
        {noDeviceSelected && <span className='errormessage'>Please select a device type</span>}
     </Space>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Devices;